import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncCourse = Load(
  () =>
    import(
      /* webpackChunkName: "course-page" */ './containers/CourseContainer'
    ),
);

const CourseRoutes = (
  <NavigationableLayout
    key="course"
    path={`${basePath}/course/:id`}
    component={AsyncCourse}
    hideFooter
    showSearchInNavbar={false}
    nonFixedNavbar
  />
);

export default CourseRoutes;
